import React from 'react';
import { Button } from '@mui/material';
import EmptyStateBox from 'src/components/common/ui/EmptyStateBox';
import { InfoOutlined } from '@mui/icons-material';
import {
  FlexColumnContainer,
  RoundedIconContainer,
} from 'src/components/styles';
import useAuthMutations from 'src/features/auth/presentation/hooks/useAuthMutations';
import { ERROR_FALLBACK_COPIES } from './RouteAccessFallback.constants';
import { RouteAccessFallbackProps } from './RouteAccessFallback.types';

const RouteAccessFallback: React.FC<RouteAccessFallbackProps> = ({
  variant = 'default',
  onActionClick,
  showLogoutCta,
}) => {
  const { logoutMutation } = useAuthMutations();
  const { title, subtitle, buttonLabel } = ERROR_FALLBACK_COPIES[variant];

  const handlePrimaryAction = () => {
    if (onActionClick === 'reload') {
      window.location.reload();
    } else if (onActionClick) {
      onActionClick();
    }
  };

  const handleLogout = () => {
    logoutMutation.mutate();
  };

  return (
    <FlexColumnContainer
      display="flex"
      justifyContent="space-between"
      alignContent="center"
      py={8}
      px={1}
      minHeight="85vh"
    >
      <EmptyStateBox
        title={title}
        subtitle={subtitle}
        icon={
          <RoundedIconContainer bgcolor={({ palette }) => palette.primary.main}>
            <InfoOutlined fontSize="large" color="inherit" />
          </RoundedIconContainer>
        }
        primaryButton={
          onActionClick ? (
            <Button
              variant="contained"
              color="primary"
              onClick={handlePrimaryAction}
            >
              {buttonLabel}
            </Button>
          ) : null
        }
      />
      {showLogoutCta && <Button onClick={handleLogout}>Cerrar sesión</Button>}
    </FlexColumnContainer>
  );
};

export default RouteAccessFallback;
